package com.fireavert.auth.reset_password.client.presentation

data class ResetPasswordViewState(
    val email: String = "",
    val loading: Boolean = false,
    val error: Boolean = false,
    val errorMessage: String = ""
)
